import React from "react";
import Typography from "@material-ui/core/Typography";

export const EventRules = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>Event Rules</u>
      </Typography>
      <p>
        1) Anyone with member tags is able to host an event at CA, and will
        receive support from the Moderation and Officer teams as needed.
      </p>
      <p>
        2) If you are a Guest, or a new Member and are having any issues with
        the modpack or teamspeak, please join the Help channel in Teamspeak at
        least 20 mins before the event start and ping @Officers to assist you.
        If you do require assistance and do not show up early, you may not be
        able to join the event as a result.
      </p>
      <p>
        3) Anyone can slot for any role - we know that many Guests and new
        members have played arma 3 before, but we ask that Guests take simpler
        roles, such as Riflemen or AARs for their first couple of events, in
        order to get a feeling for how our group works. Guests may not slot for
        any position being 'raffled'.
      </p>
      <p>
        4) Follow your chain of command. Whilst we’re not a hardcore Milsim
        unit, you should still follow instructions by your element leader. If in
        doubt, try to stay close to your element leader.
      </p>
      <p>
        5) Please comment on the AAR thread at the end of the event - all posts
        should follow the "critique + suggestion" format to help resolve any
        issues - please keep all criticism positive.
      </p>
      <p>
        6) Any complaints about specific players should be directed to a
        Moderator. Please include as much information and detail as you can to
        help the Moderator team make a decision. Any complaints of this nature
        should be kept out of AARs.
      </p>
      <p>
        7) Poor performance isn't a problem - every event is an opportunity to
        try something new and get better at it. Poor behaviour, however, is a
        problem - there are no excuses for not being civil with anyone.
      </p>
      <p>
        8) "Lone Wolfing" is discouraged - please try to maintain cohesion with
        your element leader and follow their instructions. CA's playstyle is
        very much a team game!
      </p>
      <p>
        9) Please keep ingame text chat (side chat) clear - it should only ever
        be used to report game-breaking issues directly to the missionmaker.
        Steam/Discord/TS chat should be preferred where possible.
      </p>
      <p>
        10) Intentional teamkilling is at all times prohibited unless the
        mission scenario explicitly permits it, this includes the end mission
        screen. Additionally, once the end-mission screen appears you may not
        throw frags/smokes, but as long as you're not teamkilling, firing your
        weapon as a show of support for the missionmaker is permitted.
      </p>
    </div>
  );
};

export default EventRules;
